import React, { useCallback } from 'react';
import { Image, UIHeading3 } from '@cian/ui-kit';
import { Link } from 'react-router-dom';

import { ISliderDataSchema } from '../../../repositories/journal/entities/slider/SliderDataSchema';
import { correctPathname } from '../../../utils';
import * as s from './MainPageSlide.css';

export interface IMainPageSlide extends Pick<ISliderDataSchema, 'title' | 'image'> {
  url: string;
  rubricName: string;
  rubricUrl: string;
  onSlideClick(e: React.MouseEvent): void;
  onRubricClick(e: React.MouseEvent): void;
}

/**
 * Элемент слайдера для Главной
 */
export const MainPageSlide = ({
  title,
  image,
  url,
  rubricName,
  rubricUrl,
  onSlideClick,
  onRubricClick,
}: IMainPageSlide) => {
  /** Отправляет клик по слайду родителю */
  const handleSlideClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onSlideClick(e);
    },
    [onSlideClick],
  );

  /** Отправляет клик по рубрике родителю */
  const handleRubricClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onRubricClick(e);
    },
    [onRubricClick],
  );

  return (
    <div className={s['wrapper']} onClick={handleSlideClick}>
      <div className={s['title-wrapper']}>
        <Link
          to={correctPathname(rubricUrl)}
          className={s['rubric']}
          title={`Перейти в рубрику ${rubricName}`}
          onClick={handleRubricClick}
        >
          {rubricName}
        </Link>

        <Link to={correctPathname(url)} className={s['title']} title={title} onClick={handleSlideClick}>
          <UIHeading3>{title}</UIHeading3>
        </Link>
      </div>

      <Image
        alt={title}
        borderRadius={'4px'}
        objectFit="cover"
        src={image || ''}
        theme="light"
        title={title}
        width={'100%'}
      />
    </div>
  );
};
